(function () {
  'use strict';

  const BUTTON_RESET_MS = 3000;
  const PULSE_MS = 700;
  const ICON_PULSE_CLASS = 'bt-cart-icon--pulse';
  const BADGE_PULSE_CLASS = 'bt-cart-badge--pulse';

  function setButtonAdded(button) {
    if (!button || button.disabled) return;

    const textEl =
      button.querySelector('.m-add-to-cart--text') ||
      button.querySelector('.m-add-to-cart__label') ||
      button.querySelector('[data-atc-text]');

    if (!button.dataset.btAtcOriginal) {
      const original = button.dataset.atcText || (textEl ? textEl.textContent.trim() : button.textContent.trim());
      button.dataset.btAtcOriginal = original;
    }

    const addedLabel = window.MinimogStrings?.addedToCart || 'Adicionado!';
    button.classList.add('m-add-to-cart--added');

    if (textEl) {
      textEl.textContent = addedLabel;
    } else {
      button.textContent = addedLabel;
    }

    clearTimeout(button._btAtcResetTimer);
    button._btAtcResetTimer = setTimeout(() => {
      button.classList.remove('m-add-to-cart--added');
      const label =
        button.querySelector('.m-add-to-cart--text') ||
        button.querySelector('.m-add-to-cart__label');
      const restore = button.dataset.btAtcOriginal || button.dataset.atcText;
      if (label && restore) label.textContent = restore;
    }, BUTTON_RESET_MS);
  }

  function isRendered(el) {
    return !!(el && el.getClientRects().length);
  }

  function pulseElement(el, className) {
    if (!el) return;
    el.classList.remove(className);
    void el.offsetWidth;
    el.classList.add(className);

    clearTimeout(el._btPulseTimer);
    el._btPulseTimer = setTimeout(() => {
      el.classList.remove(className);
    }, PULSE_MS);
  }

  function pulseCartFeedback() {
    document.querySelectorAll('.m-cart-icon-bubble').forEach((icon) => {
      if (!isRendered(icon)) return;
      pulseElement(icon, ICON_PULSE_CLASS);

      const badge = icon.querySelector('m-cart-count.m-cart-count');
      if (!badge || badge.classList.contains('m:hidden') || !isRendered(badge)) return;
      pulseElement(badge, BADGE_PULSE_CLASS);
    });
  }

  function onProductAdded(event) {
    if (!window.MinimogSettings?.use_ajax_atc) return;

    const detail = event.detail || {};
    if (detail.submitButton) setButtonAdded(detail.submitButton);

    // cartUpdate atualiza o badge antes deste evento; 2 rAF garante paint do contador.
    requestAnimationFrame(() => {
      requestAnimationFrame(pulseCartFeedback);
    });
  }

  function init() {
    document.addEventListener('product-ajax:added', onProductAdded);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
